export default __webpack_public_path__ + "static/media/proj16.e7010084.jpg";